import React from 'react';
import { IIconProps } from './utils';

export const Filter = ({
  fill = 'currentColor', height = 18, ...rest
}: IIconProps) => {
  const heightInt = typeof height === 'string' ? parseInt(height, 10) : height;

  return (
    <svg
      fill="none"
      height={heightInt}
      viewBox="0 0 20 18"
      width={heightInt * 10 / 9}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={`M18.9359 0.49858C19.0808 0.848011 19.0212 1.14631 18.757 1.39347L12.4544
            7.69602V17.1818C12.4544 17.5398 12.2882 17.7912 11.9558 17.9361C11.845
            17.9787 11.7385 18 11.6362 18C11.4061 18 11.2144 17.919 11.0609 17.7571L7.78822
            14.4844C7.62629 14.3224 7.54532 14.1307 7.54532 13.9091V7.69602L1.24276
            1.39347C0.97856 1.14631 0.918901 0.848011 1.06379 0.49858C1.20867 0.166193
            1.46009 0 1.81805 0H18.1817C18.5396 0 18.7911 0.166193 18.9359 0.49858Z`}
        fill={fill}
      />
    </svg>
  );
};
